module.exports = __webpack_public_path__ + "static/media/memvra-5.c7fd69c3.png";